const meta = {
  layout: 'master',
  requiresAuth: true,
};

export default [
  {
    path: '/stock',
    component: () => import(/* webpackChunkName: "stock" */ './components/Dashboard.vue'),
    meta,
  },
  {
    path: '/stock/others',
    component: () => import(/* webpackChunkName: "stock" */ './components/OtherMain.vue'),
    meta,
  },
];
